import axios from "axios";

import Config from "../../config";

const actionCriarWebhook = (data) => {
    
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/clientes/cliente/integracoes/webhooks/criar`,
        data
    });
};

export default actionCriarWebhook;
